export class RenderUtil {
  static drawPolygon(ctx, points, color) {
    ctx.beginPath();
    ctx.fillStyle = color
    ctx.moveTo(points[0].x, points[0].y)
    for (let i = 1; i < points.length; i++) {
      ctx.lineTo(points[i].x, points[i].y)
    }
    ctx.lineTo(points[0].x, points[0].y)
    ctx.stroke()
    ctx.fill()
  }

  static drawHalos(ctx, center, rot, color) {
    const num = 7
    for (let i = 0; i < num; i++) {
      this.drawHalo(ctx, center, rot + i*360/num, color, 10-0.5*(num*0.5-i))
    }
  }

  static drawHalo(ctx, center, rot, color, tick) {
    const deg = rot*Math.PI/180
    const deg2 = (rot-tick)*Math.PI/180
    const r1 = 20
    const r2 = 9000
    const c1 = {x: r1*Math.cos(deg) + center.x, y: r1*Math.sin(deg) + center.y}
    const c2 = {x: r2*Math.cos(deg) + center.x, y: r2*Math.sin(deg) + center.y}
    const c3 = {x: r2*Math.cos(deg2) + center.x, y: r2*Math.sin(deg2) + center.y}
    const c4 = {x: r1*Math.cos(deg2) + center.x, y: r1*Math.sin(deg2) + center.y}
    this.drawPolygon(ctx, [c1,c2,c3,c4], color)
  }

  static drawLine(ctx, p1, p2) {
    ctx.beginPath();
    ctx.moveTo(p1.x, p1.y);
    ctx.lineTo(p2.x, p2.y);
    ctx.stroke();
  }
}



// WEBPACK FOOTER //
// ./src/components/common/RenderUtil.js